import BusinessIcon from '@mui/icons-material/Business';
import EventNoteIcon from '@mui/icons-material/EventNote';
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import MovingIcon from '@mui/icons-material/Moving';

export const STAT_CARDS = [
  { key: "workshops",  value: 0, icon: BusinessIcon, emphasize: false },
  { key: "reservations",  value: 0, icon: EventNoteIcon, emphasize: false },
  { key: "services",  value: 0, icon: BuildOutlinedIcon, emphasize: false },
  { key: "revenue",  value: 0, icon: MovingIcon, emphasize: false },
];
export const STAT_CARD_MAP = {
  workshops: "Workshops",
  reservations: "Reservations",
  services: "Services",
  revenue: "Revenue",
};
export const VIEW_TABS = [
  { key: "workshops", icon: BusinessIcon, count: 0 },
  { key: "reservations", icon: EventNoteIcon, count: 0 },
  { key: "services", icon: BuildOutlinedIcon, count: 0 },
];
export const STATUS = {
  active: { key: "active", color: "#15803D", bg: "#E7F6EC", bar: "#22C55E" },
  inactive: { key: "inactive", color: "#B91C1C", bg: "#FDEAEA", bar: "#EF4444" },
};